// extracted by mini-css-extract-plugin
export var pillWrapper = "_m5-0";
export var showOverflow = "_m5-1";